const startRequest = (state: Object) => {
  ++state.agreements.requestsInProgress;
  return state;
};
const finishRequest = (state: Object) => {
  if (state.agreements.requestsInProgress > 0) --state.agreements.requestsInProgress;
  return state;
};

export const setLoading = state => () => startRequest(state);

export const onGetAgreementsSuccess = state => ({ payload }: Object) => {
  state.error = null;
  state.agreements.list = payload;
  return finishRequest(state);
};

export const onGetSlaSchemaSuccess = state => ({ payload }: Object) => {
  state.error = null;
  state.agreements.schema = payload;
  return finishRequest(state);
};

export const onToggleSlaClientModal = state => ({ payload }: Object) => {
  state.agreements.activeClientModal = payload;
  return state;
};

export const onGetSlaSchemaError = state => ({ payload }: Object) => {
  state.error = null;
  return finishRequest(state);
};

export const onPutAgreementsSuccess = state => ({ payload }) => {
  return finishRequest(state);
};

export const onPutAgreementsError = state => ({ payload }: Object) => {
  state.error = payload;
  return finishRequest(state);
};

export const onGetAgreementsError = state => ({ payload }: Object) => {
  state.agreements.list.content = [];
  state.error = payload;
  return finishRequest(state);
};
